import React from 'react';
import { FaPlus as FaPlusSolid } from 'react-icons/fa';

import ShortcutHint from 'components/common/ShortcutHint/ShortcutHint';
import { TASKS_GRID_QUICK_ADD_ARIA_LABEL } from 'constants/uiConstants';
import { getInputTaskTypeLabel, InputTaskType } from 'interfaces/IInputTask';

import { TaskKind } from './taskFactory';

// Display order, and the Ctrl/⌘ number that adds each type (OP-2534).
export const QUICK_ADD_TASK_OPTIONS: {
  kind: TaskKind;
  taskType: InputTaskType;
  shortcutKey: string;
}[] = [
  {
    kind: 'application',
    taskType: InputTaskType.Application,
    shortcutKey: '1',
  },
  {
    kind: 'cropEstablishment',
    taskType: InputTaskType.CropEstablishment,
    shortcutKey: '2',
  },
  { kind: 'production', taskType: InputTaskType.Production, shortcutKey: '3' },
];

interface QuickAddTaskRowProps {
  onAdd: (kind: TaskKind) => void;
}

// Sits at the top of the tasks grid, directly above the column headers
// (OP-2534): one button per task type, each with its Ctrl/⌘ shortcut, so a
// task can be added by mouse or keyboard without opening a menu. The new task
// is pinned directly beneath it.
const QuickAddTaskRow: React.FC<QuickAddTaskRowProps> = ({ onAdd }) => (
  <div
    role="group"
    aria-label={TASKS_GRID_QUICK_ADD_ARIA_LABEL}
    className="flex flex-wrap items-center gap-2 bg-white px-3 py-2"
  >
    {QUICK_ADD_TASK_OPTIONS.map(({ kind, taskType, shortcutKey }) => (
      <button
        key={kind}
        type="button"
        className="inline-flex items-center gap-2 rounded-[var(--radius-button)] border border-solid border-gray-argent bg-white px-2 py-1 text-sm font-semibold text-secondary-dark hover:bg-gray-bright"
        onClick={() => onAdd(kind)}
      >
        <FaPlusSolid className="text-success-dark" size={10} aria-hidden />
        {getInputTaskTypeLabel(taskType)}
        <span className="text-gray-muted">
          <ShortcutHint shortcutKey={shortcutKey} variant="subtle" />
        </span>
      </button>
    ))}
  </div>
);

export default QuickAddTaskRow;
